import { Component } from '@angular/core';

export interface QuickLauncherItem {
  icon: string;
  label: string;
  action?: () => void;
  href?: string;
}

@Component({
  selector: 'app-quick-launcher',
  templateUrl: './quick-launcher.component.html',
  styleUrls: ['./quick-launcher.component.scss']
})
export class QuickLauncherComponent {
  open = false;

  items: QuickLauncherItem[] = [
    { icon: 'pi pi-envelope', label: 'Mail', href: '#' },
    { icon: 'pi pi-calendar', label: 'Calendar', href: '#' },
    { icon: 'pi pi-file', label: 'Document', href: '#' },
    { icon: 'pi pi-comments', label: 'Chat', href: '#' },
    { icon: 'pi pi-book', label: 'Notes', href: '#' },
    { icon: 'pi pi-calculator', label: 'Calculator', href: '#' },
    { icon: 'pi pi-pencil', label: 'Pen', href: '#' },
    { icon: 'pi pi-search', label: 'Search', href: '#' }
  ];

  toggle(): void {
    this.open = !this.open;
  }
}
